module.exports = __webpack_public_path__ + "static/media/galafold.10d54c97.PNG";